import { request } from '../utils';
import { URL } from './constants';

export function menuItemsRequest(apiUrl) {
  return request(URL(apiUrl));
}

export default menuItemsRequest;